import template from './template';
import entry from './plugins/entry';
import entryHtml from './plugins/entryHtml';
import packageJSON from './plugins/packageJSON';
import router from './plugins/router';
import menuData from './plugins/menuData';
import globalStyle from './plugins/globalStyle';
export default {
  template,
  plugins: {
    entry,
    entryHtml,
    packageJSON,
    router,
    menuData,
    globalStyle,
  },
};
